import type { IBetBuilderCombinationSelectionDisplayRule, IBetBuilderRecommendation } from '@/interface/betBuilder';
import type { RogueModelsBetBuilderPreBuilt, RogueModelsResponsesBetBuilderPreBuiltResponse } from '@/interface/rogue';

export function formatBetBuilderRecommendation(item: RogueModelsBetBuilderPreBuilt): IBetBuilderRecommendation {
    return {
        combinationKey: item.key ?? '',
        eventId: item.matchId ?? 0,
        matchCode: item.matchCode ?? '',
        leagueId: item.leagueId ?? 0,
        selectionIds: item.selectionIds ?? [],
        maxOdds: item.maxOdds ?? 0,
        isMatchStarted: item.isMatchStarted ?? false,
    };
}

export function formatBetBuilderRecommendations(response: RogueModelsResponsesBetBuilderPreBuiltResponse): IBetBuilderRecommendation[] {
    return (response.betBuilderPreBuilts ?? []).map(formatBetBuilderRecommendation);
}

export function computeSelectionHash(displayRule: IBetBuilderCombinationSelectionDisplayRule): string {
    return btoa(JSON.stringify(displayRule))
        .replaceAll('+', '-')
        .replaceAll('/', '_')
        .replaceAll('=', '');
}
